module.exports = __webpack_public_path__ + "static/media/order-request.4f0e3316.png";